import { useUser } from "@clerk/clerk-expo";
import { useToken } from "@gluestack-style/react";
import { SiteSelect } from "components/form/SiteSelect";
import PageLoader from "components/general/PageLoader";
import { AddGroupModal } from "components/groupsite/AddGroupModal";
import TreeGroupNode from "components/navigation/TreeGroupNode";
import { Box, Button, H1, HStack, H3, Typography, Modal, Text } from "components/ui";
import { id } from "date-fns/locale";
import { Slot, router } from "expo-router";
import { CircleHelp, X } from "lucide-react-native";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { TreeNode, useGetGroupQuery, usePutGroupByIdMoveMutation, usePutGroupByIdMutation, usePostGroupMutation, useDeleteGroupByIdMutation } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { ref } from "yup";

export default function Page() {
	const resolvedPrimaryLight = useToken("colors", "primarylight");
	const { data, isLoading, isFetching } = useGetGroupQuery({});
	const isMobile = useIsMobile();
	const siteSelectRef = useRef<any>(null);
	const [isAddGroupModalVisible, setIsAddGroupModalVisible] = useState(false);
	const [handleMoveGroup] = usePutGroupByIdMoveMutation();
	const [handleAddGroup] = usePostGroupMutation();
	const [deleteGroup] = useDeleteGroupByIdMutation();
	const [contextGroupSelected, setContextGroupSelected] = useState<TreeNode | null>(null);
	const { user } = useUser();
	const companyCollection: any = user?.publicMetadata?.companyData;
	let currentCompanyName = companyCollection[user?.unsafeMetadata?.companyId as string]?.name;
	// Update internal value when external value changes
	// useEffect(() => {
	// 	setInternalValue(value);
	// }, [value]);

	if (isLoading || data == null) {
		return <PageLoader />;
	}

	const onContextMenuPress = (action: string, node: TreeNode) => {
		console.log({action});
		switch (action) {
			case "Add group":
				setContextGroupSelected(node);
				setIsAddGroupModalVisible(true);
				return;
			case "Delete":
				if( node.id ) {
					deleteGroup({ id: node.id })
				}
				return;

			default:
				setContextGroupSelected(node);
				siteSelectRef.current?.open();
		}

	};

	const moveGroup = (node: TreeNode) => {
		if (contextGroupSelected && node && contextGroupSelected.id !== undefined) {
			handleMoveGroup({
				id: contextGroupSelected.id,
				newParentId: node.id,
			});
		}
		setContextGroupSelected(null);
		siteSelectRef.current?.close();
	};

	const addGroup = async (groupData: { name: string }) => {
		if (contextGroupSelected && contextGroupSelected.id !== undefined) {
			const result = await handleAddGroup({
				group: {
					name: groupData.name,
					parent: {
						id: contextGroupSelected.id,
						name: contextGroupSelected.name || "",
					},
				},
			});

			// Navigate to the newly created group
			if ("data" in result && result.data?.id !== undefined) {
				router.push({
					pathname: "admin/groups/[id]",
					params: { id: String(result.data.id) },
				});
			}
		}
		setContextGroupSelected(null);
		setIsAddGroupModalVisible(false);
	};

	return (
		<Box paddingVertical={isMobile ? 0 : 32}>
			<AddGroupModal isVisible={isAddGroupModalVisible} onClose={() => setIsAddGroupModalVisible(false)} onSubmit={addGroup} parentGroupName={contextGroupSelected?.name || undefined} />
			<Box display="none">
				<SiteSelect onSelect={moveGroup} ref={siteSelectRef} isMulti={false} allowedTypes="Group" />
			</Box>
			{/* {!isMobile && (
				<Box flexDirection="row" mb={32} alignItems="center">
					<H1>Sites + Groups</H1>
					<Button onPress={() => window.alert("Help for this page")} ml="auto" gap={12}>
						<CircleHelp color={resolvedPrimaryLight} />
						<Text color="$primarylight">Help for this page</Text>
					</Button>
				</Box>
			)} */}

			<Box width={"$full"} flexDirection="row" padding={isMobile ? 0 : 28} bg="$basicwhite" borderRadius={16} gap={28}>
				{!isMobile && <TreeGroupNode rootNodeName={currentCompanyName} basicNode={data} level={0} defaultOpen={true} truncateTextSize={35} includeContextMenu onContextMenuPress={onContextMenuPress} />}

				<Box flex={1}>
					<Slot />
				</Box>
			</Box>
		</Box>
	);
}
